import moment from "moment";
import { OmitField } from "src/app/@shared/decorators/api-field.decorator";
import { ModelBase } from "../../abstract/model-base.model";
import { LoanInstalmentOrigin } from "./loan-instalment-origin.model";
import { LoanInstalmentPaymentStatus } from "./loan-instalment-payment-status.model";

export class LoanInstalment extends ModelBase {

    static override CLASS_NAME: string = 'LoanInstalment';

    private _bankAccountLineId!: number;
    private _capitalAmount!: number;
    private _capitalAmountOrg!: number;
    private _dueDate!: moment.Moment;
    private _insuranceAmount!: number;
    private _insuranceAmountOrg!: number;
    private _interestAmount!: number;
    private _interestAmountOrg!: number;
    private _origin!: LoanInstalmentOrigin;
    private _outstandingAfter!: number;
    private _outstandingAfterOrg!: number;
    private _paymentStatus!: LoanInstalmentPaymentStatus;
    private _penaltyAmount!: number;
    private _penaltyAmountOrg!: number;
    private _sequence!: number;
    private _tofAmount!: number;
    private _tofAmountOrg!: number;
    private _totalAmount!: number;
    private _totalAmountOrg!: number;

    @OmitField()
    public get bankAccountLineId(): number {
        return this._bankAccountLineId;
    }

    public set bankAccountLineId(value: any) {
        this._setValue('_bankAccountLineId', value, 'integer');
    }

    public get capitalAmount(): number {
        return this._capitalAmount;
    }

    public set capitalAmount(value: any) {
        this._setValue('_capitalAmount', value, 'float');
    }

    @OmitField()
    public get capitalAmountOrg(): number {
        return this._capitalAmountOrg;
    }

    public set capitalAmountOrg(value: any) {
        this._setValue('_capitalAmountOrg', value, 'float');
    }

    public get dueDate(): moment.Moment {
        return this._dueDate;
    }

    public set dueDate(value: any) {
        this._setValue('_dueDate', value, 'date');
    }

    /**
     * Année d'échéance — clé de regroupement du tableau d'amortissement (dérivée,
     * jamais envoyée à l'API : `_toApi` ne sérialise que les champs privés).
     */
    public get dueYear(): number {
        return !!this._dueDate ? this._dueDate.year() : 0;
    }

    public get insuranceAmount(): number {
        return this._insuranceAmount;
    }

    public set insuranceAmount(value: any) {
        this._setValue('_insuranceAmount', value, 'float');
    }

    @OmitField()
    public get insuranceAmountOrg(): number {
        return this._insuranceAmountOrg;
    }

    public set insuranceAmountOrg(value: any) {
        this._setValue('_insuranceAmountOrg', value, 'float');
    }

    public get interestAmount(): number {
        return this._interestAmount;
    }

    public set interestAmount(value: any) {
        this._setValue('_interestAmount', value, 'float');
    }

    @OmitField()
    public get interestAmountOrg(): number {
        return this._interestAmountOrg;
    }

    public set interestAmountOrg(value: any) {
        this._setValue('_interestAmountOrg', value, 'float');
    }

    public get origin(): LoanInstalmentOrigin {
        return this._origin;
    }

    public set origin(value: any) {
        this._setValue('_origin', value, 'LoanInstalmentOrigin');
    }

    @OmitField()
    public get outstandingAfter(): number {
        return this._outstandingAfter;
    }

    public set outstandingAfter(value: any) {
        this._setValue('_outstandingAfter', value, 'float');
    }

    @OmitField()
    public get outstandingAfterOrg(): number {
        return this._outstandingAfterOrg;
    }

    public set outstandingAfterOrg(value: any) {
        this._setValue('_outstandingAfterOrg', value, 'float');
    }

    public get paymentStatus(): LoanInstalmentPaymentStatus {
        return this._paymentStatus;
    }

    public set paymentStatus(value: any) {
        this._setValue('_paymentStatus', value, 'LoanInstalmentPaymentStatus');
    }

    public get penaltyAmount(): number {
        return this._penaltyAmount;
    }

    public set penaltyAmount(value: any) {
        this._setValue('_penaltyAmount', value, 'float');
    }

    @OmitField()
    public get penaltyAmountOrg(): number {
        return this._penaltyAmountOrg;
    }

    public set penaltyAmountOrg(value: any) {
        this._setValue('_penaltyAmountOrg', value, 'float');
    }

    @OmitField()
    public get sequence(): number {
        return this._sequence;
    }

    public set sequence(value: any) {
        this._setValue('_sequence', value, 'integer');
    }

    /**
     * Part TOF de l'échéance — dérivée côté serveur (intérêts × taux de TOF) et
     * recalculée à chaque enregistrement : jamais envoyée par le front.
     */
    @OmitField()
    public get tofAmount(): number {
        return this._tofAmount;
    }

    public set tofAmount(value: any) {
        this._setValue('_tofAmount', value, 'float');
    }

    @OmitField()
    public get tofAmountOrg(): number {
        return this._tofAmountOrg;
    }

    public set tofAmountOrg(value: any) {
        this._setValue('_tofAmountOrg', value, 'float');
    }

    @OmitField()
    public get totalAmount(): number {
        return this._totalAmount;
    }

    public set totalAmount(value: any) {
        this._setValue('_totalAmount', value, 'float');
    }

    @OmitField()
    public get totalAmountOrg(): number {
        return this._totalAmountOrg;
    }

    public set totalAmountOrg(value: any) {
        this._setValue('_totalAmountOrg', value, 'float');
    }

}
